import { render, staticRenderFns } from "./user_new_infor.vue?vue&type=template&id=1d39f66c&"
import script from "./user_new_infor.vue?vue&type=script&lang=js&"
export * from "./user_new_infor.vue?vue&type=script&lang=js&"
import style0 from "./user_new_infor.vue?vue&type=style&index=0&id=1d39f66c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports